export interface DurationSettings {
  primaryDurations: number[]; // Array of 4 duration values in minutes
  defaultDuration: number; // Default duration in minutes
}

export const BASE_DURATION_OPTIONS = [
  { value: '1', label: '1 min', minutes: 1 },
  { value: '3', label: '3 min', minutes: 3 },
  { value: '5', label: '5 min', minutes: 5 },
  { value: '10', label: '10 min', minutes: 10 },
  { value: '15', label: '15 min', minutes: 15 },
  { value: '20', label: '20 min', minutes: 20 },
  { value: '25', label: '25 min', minutes: 25 },
  { value: '30', label: '30 min', minutes: 30 },
  { value: '45', label: '45 min', minutes: 45 },
  { value: '60', label: '1 hour', minutes: 60 },
  { value: '90', label: '1.5 hours', minutes: 90 },
  { value: '120', label: '2 hours', minutes: 120 },
];

export const DEFAULT_DURATION_SETTINGS: DurationSettings = {
  primaryDurations: [3, 10, 25, 60], // Default: 3m, 10m, 25m, 1h
  defaultDuration: 10 // Default to 10 minutes
};

const STORAGE_KEY = 'durationSettings';

export function saveDurationSettings(settings: DurationSettings): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
}

export function loadDurationSettings(): DurationSettings {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      // Validate that we have exactly 4 durations and a default
      if (parsed.primaryDurations && Array.isArray(parsed.primaryDurations) && parsed.primaryDurations.length === 4) {
        return {
          primaryDurations: parsed.primaryDurations,
          defaultDuration: parsed.defaultDuration || DEFAULT_DURATION_SETTINGS.defaultDuration
        };
      }
    }
  } catch (error) {
    console.error('Failed to load duration settings:', error);
  }
  return DEFAULT_DURATION_SETTINGS;
}
